<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.666 4.16675H3.33268C2.41221 4.16675 1.66602 4.91294 1.66602 5.83341V14.1667C1.66602 15.0872 2.41221 15.8334 3.33268 15.8334H16.666C17.5865 15.8334 18.3327 15.0872 18.3327 14.1667V5.83341C18.3327 4.91294 17.5865 4.16675 16.666 4.16675Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.66602 8.33325H18.3327" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
